import { Component, inject} from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { take } from 'rxjs';
import { AuthService } from '../../../auth/services/auth.service';
import { clearProfileNotificationsList } from '../../../notification-center/store/actions/profileNotifications.action';
import {
    selectCurrentPlayerAvatar, selectCurrentPlayerExp,
    selectCurrentPlayerId,
    selectCurrentPlayerNickname,
} from '../../../profile/store/selectors/profileGeneral.selector';
import {
    selectCurrentPlayerPaymentAccountBalanceValue,
    selectCurrentPlayerPaymentAccountLPBalanceValue,
} from '../../../wallet/store/selectors/wallet.selector';
import { AppState } from '../../store/appState';
import { CdkConnectedOverlay, CdkOverlayOrigin } from '@angular/cdk/overlay';
import { AsyncPipe, NgClass, NgOptimizedImage } from '@angular/common';
import { MatRipple } from '@angular/material/core';
import { ResponseImageSetPipe } from '../../pipes/response-image-set.pipe';
import { TranslatePipe } from '@ngx-translate/core';
import { SvgIconComponent } from 'angular-svg-icon';

@Component({
    selector: 'app-edit-user-profile',
    templateUrl: './edit-user-profile.component.html',
    styleUrls: ['./edit-user-profile.component.scss'],
    imports: [
    CdkOverlayOrigin,
    MatRipple,
    NgClass,
    CdkConnectedOverlay,
    ResponseImageSetPipe,
    AsyncPipe,
    TranslatePipe,
SvgIconComponent,
        NgOptimizedImage,

    ],
})
export class EditUserProfileComponent {
    private store = inject<Store<AppState>>(Store);
    private authService = inject(AuthService);
    private router = inject(Router);
    avatar$ = this.store.select(selectCurrentPlayerAvatar);
    nickname$ = this.store.select(selectCurrentPlayerNickname);
    profileId$ = this.store.select(selectCurrentPlayerId);
    balance$ = this.store.select(selectCurrentPlayerPaymentAccountBalanceValue);
    balanceLPSignal = this.store.selectSignal(selectCurrentPlayerPaymentAccountLPBalanceValue);
    isOpen = false;
    currentUserExp$ = this.store.select(selectCurrentPlayerExp)

    get isPlayer() {
        return this.authService.isPlayer;
    }

    get isEmployee() {
        return this.authService.isEmployee;
    }

    get isOperator() {
        return this.authService.isOperator;
    }

    get isAuthorised() {
        return this.authService.isAuthorised;
    }

    switchUserProfileSettingsVisibility(): void {
        this.isOpen = !this.isOpen;
    }

    openProfileWallet(): void {
        this.router.navigate(['/wallet']);
        this.switchUserProfileSettingsVisibility();
    }

    logOut() {
        this.authService.logout();
        this.store.dispatch(clearProfileNotificationsList());
    }

    // logIn() {
    //     this.authService.login();
    // }

    openProfile() {
        if (this.isPlayer) {
            this.profileId$.pipe(take(1)).subscribe((profileId) => {
                this.router.navigate(['profile', profileId]);
            });

            this.isOpen = false;
        }
    }

    openProfileMyTournaments() {
        this.profileId$.pipe(take(1)).subscribe((profileId) => {
            this.router.navigateByUrl(`profile/${profileId}/tournaments`);
        });

        this.isOpen = false;
    }

    openProfileSettings() {
        this.profileId$.pipe(take(1)).subscribe((profileId) => {
            this.router.navigateByUrl(`profile/${profileId}/settings`);
        });

        this.isOpen = false;
    }

    openProfileMyTeams() {
        this.profileId$.pipe(take(1)).subscribe((profileId) => {
            this.router.navigateByUrl(`profile/${profileId}/teams`);
        });

        this.isOpen = false;
    }

    openProfileMyProfile() {
        this.profileId$.pipe(take(1)).subscribe((profileId) => {
            this.router.navigateByUrl(`profile/${profileId}`);
        });

        this.isOpen = false;
    }
}
